var render = function render(){var _vm=this,_c=_vm._self._c;return _c('body',{class:_vm.bodyClass,attrs:{"id":"app"}},[(_vm.$store.state.user)?_c('div',{staticClass:"wrapper"},[_c('app-nav'),_c('div',{staticClass:"content-wrapper pt-3"},[_c('div',{staticClass:"content"},[_c('router-view')],1)]),_c('app-footer')],1):[_c('router-view')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }